import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

type Props = {
  Status?: string | null;
  numero?: string | null;
  descricao?: string | null;
  onStatusChange: (novoStatus: string | null) => void;
  onNumeroChange: (novoNumero: string | null) => void;
  onDescricaoChange: (novaDescricao: string | null) => void;
  onClear: () => void;
};
export const Header = ({ Status, numero, descricao, onStatusChange, onNumeroChange, onDescricaoChange, onClear }: Props) => {
  return (
    <>
      <CascateList title="Filtros" defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
            <DefaultInput label="Numero" name="search_by_sector" value={numero ?? ""} onChangeValue={onNumeroChange} />

            <DefaultInput label="Descrição" name="search_by_sector" value={descricao ?? ""} onChangeValue={onDescricaoChange} />

            <FormControl size="small" fullWidth>
              <InputLabel id="modulo-dashboard">Status</InputLabel>
              <Select labelId="modulo-dashboard" label="Status" value={Status} onChange={(e) => onStatusChange(String(e.target.value))}>
                <MenuItem value={"T"}>Todos</MenuItem>
                <MenuItem value={"A"}>Ativos</MenuItem>
                <MenuItem value={"I"}>Inativos</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClear}
              >
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
};
